import React from "react";
import PropTypes from "prop-types";
import RadioButtons from "../RadioButtons";
import Text from "../Text/Text";
import styles from "./QuestionBody.module.scss";
import useBreakpoints from "../hooks/useBreakpoints";

/** Contains the question along with the radio options */
function QuestionBody(props) {
  const { currentQuestion, handleSelection } = props;
  const { active: activeBreakpoint } = useBreakpoints();
  return (
    <Body>
      <Text
        variant={activeBreakpoint === "subheading" ? "bodyLarge" : "h4"}
        weight="regular"
        component="p"
        className={styles.question}
      >
        {currentQuestion.question}
      </Text>
      <RadioButtons
        currentQuestion={currentQuestion}
        handleSelection={handleSelection}
      />
    </Body>
  );
}

QuestionBody.propTypes = {
  currentQuestion: PropTypes.shape({
    answer: PropTypes.string,
    dimension: PropTypes.string,
    id: PropTypes.number,
    question: PropTypes.string,
    subDimension: PropTypes.string,
  }),
  handleSelection: PropTypes.func,
};

/** Wrapper to contain the question and radio options */
function Body({ children }) {
  return <div className={styles.body}>{children}</div>;
}

Body.propTypes = {
  children: PropTypes.node,
};

export default QuestionBody;
